import type { User } from "../../../shared/types/user.type";

export const filterAssignableTeamMembers = (
  teamMembers: User[],
  activeUserIds: Set<number>
): User[] =>
  teamMembers.filter((member) => activeUserIds.has(Number(member.userId)));
